import { TextConfig } from '@st/ui-config'

export function Text({ content }: TextConfig) {
  return <span>{content}</span>
}
